import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "formInputUI" };
const _hoisted_2 = ["value"];
const _hoisted_3 = ["selected", "value"];
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InputSelect',
    props: {
        options: {},
        modelValue: {},
        placeholder: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const selectEl = ref(null);
        const options = computed(() => {
            const opts = props.options.map((option) => {
                if (typeof option === 'string' || typeof option === 'number') {
                    return {
                        key: option,
                        label: option,
                    };
                }
                return option;
            });
            if (props.placeholder) {
                if (typeof props.placeholder === 'string' || typeof props.placeholder === 'number') {
                    opts.unshift({
                        key: '',
                        label: props.placeholder,
                    });
                }
                else {
                    opts.unshift(props.placeholder);
                }
            }
            return opts;
        });
        const emit = __emit;
        const activeOption = computed(() => {
            return options.value.find(c => c.key === props.modelValue);
        });
        function updateValue() {
            const option = options.value.find(c => { var _a; return c.key === ((_a = selectEl.value) === null || _a === void 0 ? void 0 : _a.value); });
            emit('update:modelValue', option === null || option === void 0 ? void 0 : option.key);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("select", {
                    value: _ctx.modelValue,
                    onChange: _cache[0] || (_cache[0] = ($event) => (updateValue())),
                    ref_key: "selectEl",
                    ref: selectEl
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                        var _a;
                        return (_openBlock(), _createElementBlock("option", {
                            key: option.key,
                            selected: ((_a = activeOption.value) === null || _a === void 0 ? void 0 : _a.key) === option.key,
                            value: option.key
                        }, _toDisplayString(option.label), 9, _hoisted_3));
                    }), 128))
                ], 40, _hoisted_2)
            ]));
        };
    }
});
